import { type CSSProperties, type ReactElement } from 'react';

import classNames from 'classnames';

import {
  AMBIENT_DURATION_MILLISECONDS,
  CHART_SHAPES,
  ChartShapeGeometry,
} from '../ChartGraphic/ChartShapeGeometry';

import styles from './ResponsiveChartGraphic.module.css';

export const ResponsiveChartGraphic = (): ReactElement => (
  <div className={styles.responsiveDecor} aria-hidden="true">
    {CHART_SHAPES.map(shape => (
      <span
        key={shape.id}
        className={classNames(styles.decor, styles[shape.id])}
        style={
          {
            animationDuration: `${
              AMBIENT_DURATION_MILLISECONDS *
              shape.floatTiming.durationMultiplier
            }ms`,
            animationDelay: `${
              AMBIENT_DURATION_MILLISECONDS * shape.floatTiming.delayMultiplier
            }ms`,
          } satisfies CSSProperties
        }
      >
        <svg viewBox={shape.viewBox}>
          <ChartShapeGeometry shape={shape} />
        </svg>
        <i />
      </span>
    ))}
  </div>
);
